var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-5 mx-4 pb-16"},[_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }